import apiClient from "../api/axiosConfig";
import { ENDPOINTS } from "../api/endpoints";
import {
  ApiResponse,
  Stock,
  StockResponse,
  StockStatusResponse,
} from "../../types/api.types";

export const stockService = {
  getStockById: async (id: string): Promise<Stock> => {
    const response = await apiClient.get<ApiResponse<Stock>>(
      ENDPOINTS.STOCKS.GET_BY_ID,
      { params: { id } },
    );
    return response.data.data;
  },
  createStock: async (stockData: any): Promise<StockResponse> => {
    const response = await apiClient.post<ApiResponse<StockResponse>>(
      ENDPOINTS.STOCKS.CREATE,
      stockData,
    );
    return response.data.data;
  },
  getStocks: async (
    currentPage: number,
    pageSize: number,
    code?: string,
    statusId?: string,
    dateFrom?: string,
    dateTo?: string,
  ): Promise<StockResponse> => {
    const response = await apiClient.get<ApiResponse<StockResponse>>(
      ENDPOINTS.STOCKS.GET_ALL,
      {
        params: {
          page: currentPage,
          rowPerPage: pageSize,
          code: code || undefined,
          status: statusId || undefined,
          dateFrom: dateFrom || undefined,
          dateTo: dateTo || undefined,
        },
      },
    );
    return response.data.data;
  },
  deactivateStock: async (id: string): Promise<{ message: string }> => {
    const response = await apiClient.post<ApiResponse<{ message: string }>>(
      ENDPOINTS.STOCKS.DEACTIVATE,
      {},
      { params: { id } },
    );
    return response.data;
  },
  activateStock: async (id: string): Promise<{ message: string }> => {
    const response = await apiClient.post<ApiResponse<{ message: string }>>(
      ENDPOINTS.STOCKS.ACTIVATE,
      {},
      { params: { id } },
    );
    return response.data;
  },
  cancelStock: async (
    id: string,
    observation: string,
  ): Promise<{ message: string }> => {
    const response = await apiClient.post<ApiResponse<{ message: string }>>(
      ENDPOINTS.STOCKS.CANCEL,
      { stockHeaderId: id, observation: observation },
    );
    return response.data;
  },
  arrivedStock: async (
    id: string,
    observation: string,
  ): Promise<{ message: string }> => {
    const response = await apiClient.post<ApiResponse<{ message: string }>>(
      ENDPOINTS.STOCKS.ARRIVED,
      {
        stockHeaderId: id,
        observation: observation,
      },
    );
    return response.data;
  },
  updateStock: async (id: string, stockData: any): Promise<StockResponse> => {
    const response = await apiClient.post<ApiResponse<StockResponse>>(
      ENDPOINTS.STOCKS.UPDATE,
      { ...stockData, stockHeaderId: id },
    );
    return response.data.data;
  },
  updateStockItems: async (items: any[]): Promise<any> => {
    const response = await apiClient.patch<ApiResponse<any>>(
      ENDPOINTS.STOCKS.UPDATE_ITEMS,
      { items },
    );
    return response.data;
  },
  getStatuses: async (): Promise<StockStatusResponse[]> => {
    const response = await apiClient.get<ApiResponse<StockStatusResponse[]>>(
      ENDPOINTS.STOCKS.GET_STATUSES,
    );
    return response.data.data;
  },
  getHistory: async (
    stockId: string,
    page: number,
    rowsPerPage: number,
    dateFrom?: string,
    dateTo?: string,
  ): Promise<any> => {
    const response = await apiClient.get<ApiResponse<any>>(
      ENDPOINTS.STOCKS.GET_HISTORY,
      {
        params: {
          stockHeaderId: stockId,
          page,
          rowPerPage: rowsPerPage,
          dateFrom: dateFrom || undefined,
          dateTo: dateTo || undefined,
        },
      },
    );
    return response.data.data;
  },

  getHistoryItem: async (stockHistoryId: string): Promise<any> => {
    const response = await apiClient.get<ApiResponse<any>>(
      ENDPOINTS.STOCKS.GET_HISTORY_ITEM,
      {
        params: {
          stockHistoryId: stockHistoryId,
        },
      },
    );
    return response.data.data;
  },
  getItems: async (
    stockHeaderId: string,
    page: number,
    rowsPerPage: number,
    product?: string,
  ): Promise<any> => {
    const response = await apiClient.get<ApiResponse<any>>(
      ENDPOINTS.STOCKS.GET_ITEMS,
      {
        params: {
          stockHeaderId,
          page,
          rowPerPage: rowsPerPage,
          product: product || undefined,
        },
      },
    );
    return response.data.data;
  },
  getOrderId: async (clientId: string): Promise<any> => {
    const response = await apiClient.get<ApiResponse<any>>(
      ENDPOINTS.STOCKS.GET_ORDER_ID,
      {
        params: {
          clientId,
        },
      },
    );
    return response.data.data;
  },
};
